export const excludedDivisions = ["99", "912", "930", "970"]